import { Instance, types } from 'mobx-state-tree';

import { getDocuments } from '@common/api/documents';
import DocumentsItem from '@common/models/Documents/DocumentsItem';
import TableData, { ITableDataQuery } from '@common/models/TableData';

const Documents = types.compose(
	TableData,
	types
		.model({
			data: types.optional(types.array(DocumentsItem), []),
			group_ids: types.maybe(types.optional(types.string, '')),
			service_id: types.maybe(types.number),
		})
		.volatile(() => ({}))
		.actions((self) => ({
			_fetch: (query: ITableDataQuery) =>
				getDocuments({
					...query,
					...(self.group_ids && { group_ids: self.group_ids }),
					...(self.service_id && { service_id: self.service_id }),
				}),
		})),
);

export default Documents;

export interface IDocumentsModel extends Instance<typeof Documents> {}
